import stickyAddToCartMobile from './mobile';
import stickyAddToCartDesktop from './desktop';

export default () => {
  if (!$('.template-product').length) {
    return;
  }

  stickyAddToCartMobile();
  stickyAddToCartDesktop();
};
